import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateSleepActivityCompletion(
  patient: Patient | null | undefined,
) {
  const lifestyle = (patient as any)?.lifestyle;

  // Step 1: Sleep hours answered
  const hasSleep =
    lifestyle?.minHoursOfSleep != null && lifestyle?.maxHoursOfSleep != null;

  // Step 2: Exercise flag answered
  const hasExerciseAnswer =
    lifestyle?.isExercising !== undefined && lifestyle?.isExercising !== null;

  // Step 3: If exercising, has hours
  const hasExerciseDetails =
    lifestyle?.isExercising === false ||
    (lifestyle?.isExercising === true &&
      lifestyle?.minHoursOfExercise != null &&
      lifestyle?.maxHoursOfExercise != null);

  const total = 3;
  const completed =
    (hasSleep ? 1 : 0) +
    (hasExerciseAnswer ? 1 : 0) +
    (hasExerciseDetails ? 1 : 0);
  const percent = completed / total;
  const label = `${completed}/${total} answered`;

  return { percent, label, completed, total };
}
